export default "__VITE_ASSET__DqP0X8$P__"